/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon16Solid = forwardRef('MathDeltaIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.668 2.572 1.884 11.81A1.5 1.5 0 0 0 3.216 14h9.568a1.5 1.5 0 0 0 1.332-2.19L9.332 2.572c-.56-1.08-2.105-1.08-2.664 0Zm.164 3.654-2.778 5.412a.25.25 0 0 0 .223.364h5.555a.25.25 0 0 0 .222-.364L7.277 6.226a.25.25 0 0 0-.445 0Z" })));
});
